// extracted by mini-css-extract-plugin
export default {"sklandReturn":"fxCDX7","skland":"oAEJGm"};